/**

 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
export function parseTime(time, cFormat) {
    if (arguments.length === 0) {
        return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
            time = parseInt(time)
        }
        if ((typeof time === 'number') && (time.toString().length === 10)) {
            time = time * 1000
        }
        date = new Date(time)
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
        if (result.length > 0 && value < 10) {
            value = '0' + value
        }
        return value || 0
    })
    return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
    if (('' + time).length === 10) {
        time = parseInt(time) * 1000
    } else {
        time = +time
    }
    const d = new Date(time)
    const now = Date.now()

    const diff = (now - d) / 1000

    if (diff < 30) {
        return '刚刚'
    } else if (diff < 3600) {
        // less 1 hour
        return Math.ceil(diff / 60) + '分钟前'
    } else if (diff < 3600 * 24) {
        return Math.ceil(diff / 3600) + '小时前'
    } else if (diff < 3600 * 24 * 2) {
        return '1天前'
    }
    if (option) {
        return parseTime(time, option)
    } else {
        return (
            d.getMonth() +
            1 +
            '月' +
            d.getDate() +
            '日' +
            d.getHours() +
            '时' +
            d.getMinutes() +
            '分'
        )
    }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
    url = url == null ? window.location.href : url
    const search = url.substring(url.lastIndexOf('?') + 1)
    const obj = {}
    const reg = /([^?&=]+)=([^?&=]*)/g
    search.replace(reg, (rs, $1, $2) => {
        const name = decodeURIComponent($1)
        let val = decodeURIComponent($2)
        val = String(val)
        obj[name] = val
        return rs
    })
    return obj
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength(str) {
    // returns the byte length of an utf8 string
    let s = str.length
    for (var i = str.length - 1; i >= 0; i--) {
        const code = str.charCodeAt(i)
        if (code > 0x7f && code <= 0x7ff) s++
        else if (code > 0x7ff && code <= 0xffff) s += 2
        if (code >= 0xDC00 && code <= 0xDFFF) i--
    }
    return s
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
    const newArray = []
    for (let i = 0; i < actual.length; i++) {
        if (actual[i]) {
            newArray.push(actual[i])
        }
    }
    return newArray
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
    if (!json) return ''
    return cleanArray(
        Object.keys(json).map(key => {
            if (json[key] === undefined) return ''
            return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
        })
    ).join('&')
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
    const search = url.split('?')[1]
    if (!search) {
        return {}
    }
    return JSON.parse(
        '{"' +
        decodeURIComponent(search)
            .replace(/"/g, '\\"')
            .replace(/&/g, '","')
            .replace(/=/g, '":"')
            .replace(/\+/g, ' ') +
        '"}'
    )
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val) {
    const div = document.createElement('div')
    div.innerHTML = val
    return div.textContent || div.innerText
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
    if (typeof target !== 'object') {
        target = {}
    }
    if (Array.isArray(source)) {
        return source.slice()
    }
    Object.keys(source).forEach(property => {
        const sourceProperty = source[property]
        if (typeof sourceProperty === 'object') {
            target[property] = objectMerge(target[property], sourceProperty)
        } else {
            target[property] = sourceProperty
        }
    })
    return target
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
    if (!element || !className) {
        return
    }
    let classString = element.className
    const nameIndex = classString.indexOf(className)
    if (nameIndex === -1) {
        classString += '' + className
    } else {
        classString =
            classString.substr(0, nameIndex) +
            classString.substr(nameIndex + className.length)
    }
    element.className = classString
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
    if (type === 'start') {
        return new Date().getTime() - 3600 * 1000 * 24 * 90
    } else {
        return new Date(new Date().toDateString())
    }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
    let timeout, args, context, timestamp, result

    const later = function () {
        // 据上一次触发时间间隔
        const last = +new Date() - timestamp

        // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
        if (last < wait && last > 0) {
            timeout = setTimeout(later, wait - last)
        } else {
            timeout = null
            // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
            if (!immediate) {
                result = func.apply(context, args)
                if (!timeout) context = args = null
            }
        }
    }

    return function (...args) {
        context = this
        timestamp = +new Date()
        const callNow = immediate && !timeout
        // 如果延时不存在，重新设定延时
        if (!timeout) timeout = setTimeout(later, wait)
        if (callNow) {
            result = func.apply(context, args)
            context = args = null
        }

        return result
    }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
    if (!source && typeof source !== 'object') {
        throw new Error('error arguments', 'deepClone')
    }
    const targetObj = source.constructor === Array ? [] : {}
    Object.keys(source).forEach(keys => {
        if (source[keys] && typeof source[keys] === 'object') {
            targetObj[keys] = deepClone(source[keys])
        } else {
            targetObj[keys] = source[keys]
        }
    })
    return targetObj
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
    return Array.from(new Set(arr))
}

/**
 * @returns {string}
 */
export function createUniqueString() {
    const timestamp = +new Date() + ''
    const randomNum = parseInt((1 + Math.random()) * 65536) + ''
    return (+(randomNum + timestamp)).toString(32)
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
    return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
    if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
    if (hasClass(ele, cls)) {
        const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
        ele.className = ele.className.replace(reg, ' ')
    }
}

const addZero = num => num < 10 ? '0' + num : num
/*
* 日期格式化
* @return '2018-07-11';
* */
export function formatDate(time) {
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if (typeof time === 'string') {
            date = new Date(time.replace(/-/g, '/'))
        }
        if (typeof time === 'number') {
            date = new Date(time)
        }
    }
    const year = date.getFullYear()
    const month = date.getMonth()
    const day = date.getDate()
    return year + '-' + addZero(month + 1) + '-' + addZero(day)
}
/*
* 日期格式化
* @return '2018-07-11';
* */
export function formatDatetime(date) {
    date = date ? (date instanceof Date ? date : new Date(date)) : new Date()
    const year = date.getFullYear()
    const month = date.getMonth()
    const day = date.getDate()
    const hours = date.getHours()
    const minutes = date.getMinutes()
    const seconds = date.getSeconds()
    return year + '-' + addZero(month + 1) + '-' + addZero(day) + ' ' + addZero(hours) + ':' + addZero(minutes) + ':' + addZero(seconds)
}
/*
* 根据开始时间计算结束时间
 * 输入 '2019-11-29' 年'1' 月'1' 日'1'
 * @return '2019-04-11';
* */
export function getEndDate(date, years, months, days) {
    const reg = /^([1-9]\d*|[0]{1,1})$/
    if (!date || (!reg.test(years) && !reg.test(months) && !reg.test(days))) { return '' }
    const num = years / 1 * 12 + months / 1
    let year, month, day
    date = date instanceof Date ? formatDate(date) : date
    const arr = date.split('-')
    const year1 = arr[0] / 1 // 获取当前日期的年份
    const month1 = arr[1] / 1 // 获取当前日期的月份
    const day1 = arr[2] / 1 // 获取当前日期的日
    years = years / 1
    months = months / 1
    days = days / 1
    if (!years && !months) { // 只输入天数
        date = new Date(date.replace(/-/g, '/'))
        return formatDate(date.setDate(date.getDate() + days - 1))
    }
    let month2 = (month1 + num) % 12
    year = year1
    if (month2 == 0) { month2 = 12 }
    // 可能跨年
    if ((month1 + num) > 12) {
        if ((month1 + num) % 12 === 0) {
            // 整年不余月 || 截止日期是12月31日
            year = year1 + parseInt((month1 + num) / 12) - 1
        } else {
            if (day1 == 1 && (month1 + num) % 12 === 1) {
                // 余1月，1号
                year = year1 + parseInt((month1 + num) / 12) - 1
            } else {
                year = year1 + parseInt((month1 + num) / 12)
            }
        }
    }

    if (day1 == 1) {
        if ((month1 + num) % 12 === 1) {
            month = 12
        } else if (month2 > 1) {
            month = month2 - 1
        } else {
            month = month1
        }
        day = new Date(year, month, 0).getDate()
    } else if (day1 >= new Date(year, month2, 0).getDate()) {
        // debugger
        month = month2
        day = new Date(year, month, 0).getDate() - 1
    } else {
        month = month2
        day = day1 - 1
    }
    if (month < 10) { month = '0' + month }
    if (day < 10) { day = '0' + day }
    // return (year + '-' + month + '-' + day)
    date = new Date(year + '/' + month + '/' + day)
    date.setDate(date.getDate() + days)
    return formatDate(date)
}

/*
* 计算几天后日期
 * 输入 '2019-11-29' 年'1' 月'1' 日'1'
 * @return '2019-04-11';
* */
export function getNdaysDate(startDate, days) {
    const date = startDate instanceof Date ? startDate : new Date(startDate.replace(/-/g, '/'))
    date.setDate(date.getDate() + days / 1)
    return formatDate(date)
}
/*
* 计算倒计时
 * 输入 '2019-11-29 00:00:00'
 * @return '[1,1,1,1]';日，时，分，秒
* */
export function getCountdown(date) {
    let leftTime = new Date(date.replace(/-/g, "/")) - new Date() //计算剩余的毫秒数 
    let days = parseInt(leftTime / 1000 / 60 / 60 / 24, 10); //计算剩余的天数 
    let hours = parseInt(leftTime / 1000 / 60 / 60 % 24, 10); //计算剩余的小时 
    let minutes = parseInt(leftTime / 1000 / 60 % 60, 10);//计算剩余的分钟 
    let seconds = parseInt(leftTime / 1000 % 60, 10);//计算剩余的秒数 
    return [days, hours, minutes, seconds]
}
/*
* 计算下一个整分点时间
 * 输入 '2019-11-29 00:00:00'
 * @return '[1,1,1,1]';日，时，分，秒
* */
export function getMinuteInteger(date) {
    let d = new Date(date.slice(0, 16).replace(/-/g, "/")).getTime() + 62 * 1000
    return formatDatetime(d)
}
/*
* 取数组中间值
 * 输入 [1,2,3]
 * @return 2;
* */
export function getMiddle(arr) {
    const sortArr = arr.sort()
    return sortArr[Math.floor(sortArr.length / 2)]
}
/*
  *带小数的值计算
  *参数f为计算后的值，digit为保留几位小数（1.22+2.11,2）
*/
export function formatNum(f, digit) {
    const m = Math.pow(10, digit)
    return parseInt(f * m, 10) / m
}
// 两个浮点数求和
export function accAdd(num1, num2) {
    let r1, r2, m
    try {
        r1 = num1.toString().split('.')[1].length
    } catch (e) {
        r1 = 0
    }
    try {
        r2 = num2.toString().split('.')[1].length
    } catch (e) {
        r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2))
    // return (num1*m+num2*m)/m;
    return Math.round(num1 * m + num2 * m) / m
}

// 两个浮点数相减
export function accSub(num1, num2) {
    let r1, r2, m, n
    try {
        r1 = num1.toString().split('.')[1].length
    } catch (e) {
        r1 = 0
    }
    try {
        r2 = num2.toString().split('.')[1].length
    } catch (e) {
        r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2))
    n = (r1 >= r2) ? r1 : r2
    return (Math.round(num1 * m - num2 * m) / m).toFixed(n)
}

// 相乘
export function accMul(num1, num2) {
    var m = 0; var s1 = num1.toString(); var s2 = num2.toString()
    try { m += s1.split('.')[1].length } catch (e) { }
    try { m += s2.split('.')[1].length } catch (e) { }
    return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
}
/*
  *根据参数合并同类项
  *data:数组,t:合并所根据的字段名
*/
export function mergeRowCol(data, t) {
    const arr = []// 获取所有t
    const arr1 = []
    const arr2 = []// 返回的最终格式
    data.forEach(d => {
        if (arr.indexOf(d[t]) === -1) {
            arr.push(d[t])
        }
    })
    arr.forEach(d => {
        const obj = {
            name: d,
            value: []
        }
        data.forEach(e => {
            if (e[t] === obj.name) {
                obj.value.push(e)
            }
        })
        arr1.push(obj)
    })
    arr1.forEach(d => {
        let first = true
        d.value.forEach(e => {
            e.rowspan = first ? d.value.length : 0
            arr2.push(e)
            first = false
        })
    })
    return arr2
}
/*
 *数组根据指定字段去重
*/
export function filterArr(arr, name) {
    const hash = {}
    return arr.reduce((ss, item) => { // reduce累计器, ss是具体满足条件后返回的数据, item是数组依次循环的每一项
        hash[item[name]] ? '' : hash[item[name]] = true && ss.push(item)
        // 1、判断对象的键值是否存在
        return ss
    }, [])
}
